import React from "react";

const ConfirmSMSModal = ({ contact, onConfirm, onCancel }) => {
  if (!contact) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center backdrop-blur-md z-50 p-4">
      <div className="bg-white p-6 rounded-md shadow-md w-96">
        <h3 className="text-xl font-semibold mb-4">Confirm SMS</h3>
        <p className="text-gray-600 mb-6">
          Are you sure you want to send a feedback SMS to{" "}
          <b>{contact.name}</b> at <b>{contact.phone_number}</b>?
        </p>

        <div className="flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="bg-gray-500 text-white px-4 py-2 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="bg-green-600 text-white px-4 py-2 rounded-md"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmSMSModal;
